import React from 'react';

import { ProjectContext } from '../../../../state/project-state/project-state';
import { TreeContext } from '../../state/folder-tree-state';

const FolderPath = () => {
  const { project } = React.useContext(ProjectContext);
  const { selectedFolderChain } = React.useContext(TreeContext);

  /**
   * Returns path to current folder, represented by a list beginning from
   * root folder (project) name to specified folder.
   */
  const getPathToCurrentFolder = () => {
    return [project.name.toUpperCase(), ...selectedFolderChain.map((x) => x.name)];
  };

  // Returns element like "<strong>Folder A</strong / <strong>Folder B</strong / ...".
  return getPathToCurrentFolder()
    .map<React.ReactNode>((folderName, index) => <strong key={index}>{folderName}</strong>)
    .reduce((prev, curr) => [prev, ' / ', curr]) as React.ReactElement;
};

export { FolderPath };
